import { gql } from '@apollo/client';

const GET_USER_PROVIDERS = gql`
  query($userId: String!) {
    findUserProviders(where: { user_id: { equals: $userId } }) {
      first_name
      last_name
      organization_name
      middle_initial
      address_1
      provider_type
      id
      credentials
      provider_role
    }
  }
`;

export default GET_USER_PROVIDERS;
